<template>
	<div id="qvo-app">
		<titlebar />
		<notificationCenter />
		<navbar />
		<main id="content" class="dashboard">
			<h1>Overview</h1>

			<div class="summary">
				<div class="summary-controls">
					<div class="filter-date">
						<!--<multiselect
							v-model="filterDate"
							:options="filterDateOptions"
							:searchable="false"
							:close-on-select="true"
							:allow-empty="false"
							:showLabels="false">
						</multiselect>-->
						<v-select :items="filterDateOptions" v-model="filterDate" item-value="text" outlined></v-select>
					</div>
					<div class="filter-decisions">
						<togglebutton v-model="showDecisionPay" :name="'DecisionPayToggle'" :labels="true">Paid</togglebutton>
						<togglebutton v-model="showDecisionDeny" :name="'DecisionDenyToggle'" :labels="true">Denied</togglebutton>
						<togglebutton
							v-model="showDecisionRefer"
							:name="'DecisionReferToggle'"
							:labels="true"
						>Referred</togglebutton>
					</div>
				</div>
				<div class="decision-summary-container">
					<div class="decision-summary-block decision-pay">
						<div class="decision-summary-tag">Pay</div>
						<div class="decision-summary-value">80</div>
					</div>
					<div class="decision-summary-block decision-deny">
						<div class="decision-summary-tag">Deny</div>
						<div class="decision-summary-value">100</div>
					</div>
					<div class="decision-summary-block decision-refer">
						<div class="decision-summary-tag">Refer</div>
						<div class="decision-summary-value">20</div>
					</div>
					<div class="decision-summary-block decision-total">
						<div class="decision-summary-tag">Total</div>
						<div class="decision-summary-value">200</div>
					</div>
				</div>

				<div class="decision-overview-graph">
					placeholder -- will likely fill with data that we don't have yet and
					<a
						href="https://apexcharts.com/vue-chart-demos/"
					>ApexCharts</a>
				</div>
			</div>
		</main>
		<footnote />
	</div>
</template>

<script>
	import { mapActions /*, mapState, mapGetters*/ } from "vuex";

	export default {
		name: "dashboard",
		data() {
			return {
				filterDateOptions: [
					"Last 30 Days",
					"Last 60 Days",
					"Last 90 Days",
					"Date Range"
				],
				filterDate: "Last 30 Days",
				showDecisionPay: true,
				showDecisionDeny: true,
				showDecisionRefer: true
			};
		},
		methods: {
			...mapActions(["retrieveInitialDecision"]), // imports named actions from the store
			async testAPI() {
				await this.retrieveInitialDecision();
			}
		}
	};
</script>

<!-- Page-Specific Style Import (don't edit here) -->
<style lang="scss">
	@import "@/design/views/dashboard.scss";
</style>
